<template>
    <div class="grid-content">
        <div v-if="normalizedCriteria.hasConditions">
            <div class="stack-s" v-for="item in items">
                <span class="chip inline-s">
                    <condition-item-summary
                        :condition="item"
                        :field-provider="fieldProvider"/>
                </span>
            </div>
        </div>
        <div class="grid-item" v-else>
            <slot name='no-content'>
                No conditions are defined. All of the actions will execute.
            </slot>
        </div>
    </div>
</template>

<script>
    import getField from '@/modules/rules-engine/components/common/get-field';
    import NormalizedCriteria from '@/components/query/adapters/criteria/normalized-criteria';

    export default {
        name: 'condition-summary',
        components: {
            ConditionItemSummary: () => import('@/modules/rules-engine/components/condition-summary/condition-item-summary'),
        },
        props: {
            criteria: Object,
            fieldProvider: Object,
        },
        computed: {
            normalizedCriteria() {
                return new NormalizedCriteria(this.criteria, this.fieldProvider);
            },
            items() {
                return this.normalizedCriteria.getConditions();
            },
        },
        methods: {
            getField,
        },
    };
</script>
